import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';
import * as React from 'react';
import {
  AnalysisConfigurationGq,
  AnalysisConfigurationGqProps,
} from '../../models/AnalysisConfigurationGq';

export default function useUpdateAnalysisConfigurationGq() {
  const [mutation, mutationResult] = useMutation<ResponseGq, Variables>(gqTag);

  return React.useCallback(
    (command: CommandGq) =>
      mutation({ variables: { command } }).then(
        (result) => result.data.projects.updateAnalysisConfiguration.analysisConfiguration
      ),
    []
  );
}

const gqTag = gql`
  mutation UpdateAnalysisConfiguration($command: UpdateAnalysisConfigurationCommand!) {
    projects {
      updateAnalysisConfiguration(command: $command) {
        analysisConfiguration { ${AnalysisConfigurationGqProps} }
      }
    }
  }
`;

interface Variables {
  command: CommandGq;
}

export interface UpdateAnalysisConfigurationCommandGq extends CommandGq {}

export interface CommandGq {
  analysisConfigurationId: number;
  analysisFilter?: string;
  title?: string;
  projectId: number;
}

export interface ResponseGq {
  projects: {
    updateAnalysisConfiguration: {
      analysisConfiguration: AnalysisConfigurationGq;
    };
  };
}
